import { IconGraph } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { ProjectHoursBudgetCaptureBlock as RenderProjectHoursBudgetCaptureBlock } from '../../templateRenderer/CaptureBlocks/ProjectHoursBudgetCaptureBlock'
import { ProjectHoursBudgetDisplayBlock as RenderProjectHoursBudgetDisplayBlock } from '../../templateRenderer/DisplayBlocks/ProjectHoursBudgetDisplayBlock'
import {
  ProjectHoursBudgetCaptureBlock,
  ProjectHoursBudgetDisplayBlock,
} from '../../types/blueprint'

import { BaseBlockConfig, Field, TypeOption } from './_BaseBlockConfig'

import { BuildPassModule, TemplateType } from 'types/api.graphql'

class Config extends BaseBlockConfig<ProjectHoursBudgetCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'projectHoursBudget' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Project hours budget',
    icon: IconGraph,
    exclusiveTemplateTypes: [TemplateType.SiteDiary],
    helpText: 'Set your project completion % for project hours budgeting',
    builderModule: BuildPassModule.HoursBudgetReport,
  }

  public override blockFieldsConfig: Field[] = []

  public override mapFormValueToBlock(
    block: ProjectHoursBudgetCaptureBlock,
    value: ProjectHoursBudgetCaptureBlock['value']
  ): ProjectHoursBudgetCaptureBlock {
    return { ...block, value }
  }

  public override renderBlock(
    block: ProjectHoursBudgetCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderProjectHoursBudgetCaptureBlock block={block} rules={rules} />
  }

  public override renderDisplayBlock(
    block: ProjectHoursBudgetDisplayBlock
  ): React.ReactNode {
    return <RenderProjectHoursBudgetDisplayBlock block={block} />
  }
}

export const ProjectHoursBudgetCaptureBlockConfig = new Config()
